import React from 'react';
import './visionmission.css';  
import img from "../../assets/about/about2.jpeg";

function VisionMission() {
  return (
    <div className="container  vm-container-project d-flex">
 
      <div className="image-container-vm">
        <img src={img} alt="Your Image" className="image-vm" />
      </div>

     
      <div className="text-container">
        <div className="vision">
          <h3>Vision</h3>
          <div className="underline-vission-mission"></div>
          <p style={{ textIndent:"30px", textAlign:"justify"}}>
            Our vision is to build sustainable, innovative, and high-quality structures that enrich communities and elevate the construction industry.
            We strive to set new standards of excellence through commitment to safety, integrity, and customer satisfaction.
          </p>
        </div>
        <div className="mission">
          <h3>Mission</h3>
          <div className="underline-vission-mission"></div>
     
          <p style={{ textIndent:"30px", textAlign:"justify"}}>
            Our mission is to deliver exceptional construction and property development solutions that meet the evolving needs of our clients.
            We are committed to quality craftsmanship, sustainable practices, and fostering strong partnerships.
            By consistently delivering on time and within budget, we aim to exceed client expectations while contributing to the growth and improvement of the communities we serve.
          </p>
        </div>
      </div>
    </div>
  );
}

export default VisionMission;
